import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const ManageEmployeesWrapper = (): ReactElement => <Outlet />;

export default ManageEmployeesWrapper;
